import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';

import '../Resources/dashboard.css';

function Usersidebar(){

     //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const logname=sessionStorage.getItem("logName00");



 useEffect(()=>{
   

  //Checking if user loggedin
  if(((logstatus==null)||(logstatus==""))&&((logid==null)||(logid==""))&&((token==null)||(token==" "))){
    window.location.replace("/login");
  }


  },[])

return(
    <>
      {/*} partial:partials/_sidebar.html */}
      <nav class="sidebar sidebar-offcanvas" id="sidebar">
        <ul class="nav">
          <li class="nav-item">
            <a href="/" class="nav-link flex-column">
           <div  /*class="nav-profile-image" */ > 
                <img src="images/logo.jpeg" alt="profile" style={{height:"9rem", width:"9rem"}} />
                {/*}change to offline or busy as needed*/}
            </div>
            {/*}  <div class="nav-profile-text d-flex ms-0 mb-3 flex-column">
                <span class="font-weight-semibold mb-1 mt-2 text-center">Sumit Enterprises</span>
                <span class="text-secondary icon-sm text-center">Id : 9887771</span>
              </div>*/}
            </a>
          </li>
        {/*  <li class="nav-item">
            <a class="nav-link d-block" href="/adminpanel-login">
            <div class="nav-profile-text d-flex ms-0 mb-3 flex-column">
            {/*}    <span class="font-weight-semibold mb-1 mt-2 text-center">Sumit Enterprises</span>
                <span class="text-secondary icon-sm text-center">Id : 9887771</span> */}
            {/*}  </div>
            </a>
          </li> */}
          <hr/>
        {/* <li class="pt-2 pb-1">
            <span class="nav-item-head">CUSTOMERS PANEL</span>
          </li> */}
        {/*}  <li class="nav-item">
          <a class="nav-link" href="">
              <i class="mdi mdi-account-multiple-outline menu-icon"></i>
              <span class="menu-title">Dashboard</span>
            </a>
          </li> */}
          <li class="nav-item">
         
     
            <a class="nav-link" href="/user-dashboard">
              <i class="mdi mdi-account-circle menu-icon"></i>
              <span class="menu-title">Dashboard</span>
            </a>
          </li>
           <li class="nav-item">
            <a class="nav-link" href="/user-all-documents">
              <i class="mdi mdi-file-chart menu-icon"></i>
              <span class="menu-title">Documents</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/user-projects">
              <i class="mdi mdi-package menu-icon"></i>
              <span class="menu-title">Projects</span>
            </a>
          </li>
        </ul>
      </nav>
    </>

);

}

export default Usersidebar;